import { defineStore } from 'pinia'
import { IStore } from '@/contracts/modules/libre/stores/IStore'

export default defineStore('modulesLibreV1', {
  state: (): IStore => {
    return {
      nodes: {},
      version: 0,
      selected: null,
      pending: [],
    }
  },
})
